import axios from 'axios';
import { getUserToken } from './utils/user.utils';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  const token = getUserToken()
  // it can be called from login side , there is no token in this case
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      fallBackLoginFailed(); // Redirect to login page
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;

const fallBackLoginFailed = () => {
  localStorage.removeItem('userDetails');
  localStorage.removeItem('isLoggedIn');
  window.location.href = process.env.REACT_APP_BaseName + '/';
}
